import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, staff = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-black text-white">
        <div className="font-display text-3xl tracking-wide animate-pulse">LOADING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (staff && !["admin", "coach"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
